// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Y2vF","footer":"ModalUpdate_footer__2zJVp"};